import { css, jsx } from '@emotion/core';
import { Collapse, Icon } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { bp, colors } from '@/styles';

import PanelContent from './PanelContent';

const style = {
  accordion: css`
    margin-left: -16px;
    margin-right: -16px;
    background-color: transparent;
    border-bottom: none;
    @media ${bp.sm} {
      margin-left: 0;
      margin-right: 0;
    }
  `,
  panel: css`
    box-shadow: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
    border-radius: 2px;
    margin-bottom: 16px;
    background-color: white;
    border-bottom: none !important;
    .ant-collapse-header {
      padding: 31px 16px 31px 72px !important;
      font-weight: 900;
      font-size: 2rem;
      line-height: 3.2rem !important;
      color: ${colors.primaryBlue} !important;
      &[aria-expanded='true'] {
        color: ${colors.primaryRed} !important;
      }
      .anticon {
        font-size: 2.6rem !important;
        margin-left: 12px;
        &.anticon-info-circle {
          font-size: 12px !important;
          margin: 0 0.4rem 0 0 !important;
        }
      }
      .ant-collapse-content {
        border-bottom: 0;
      }
      & + div .ant-collapse-header {
        font-size: 1.8rem;
        line-height: 3rem;
      }
      @media ${bp.md} {
        font-size: 2.8rem;
        line-height: 3.6rem;
        & + div .ant-collapse-header {
          font-size: 2rem;
          line-height: 3.2rem;
        }
      }
    }
  `,
};

const { Panel } = Collapse;

const Accordion = ({ panels, id, handleCollapseChange, defaultActiveKey }) => {
  return (
    <Collapse
      accordion
      bordered={false}
      defaultActiveKey={defaultActiveKey || `accordion-panel-${id}-${0}`}
      expandIcon={({ isActive }) => <Icon type="down" rotate={isActive ? 180 : 0} />}
      className="outerpanel"
      css={style.accordion}
      key={`${id}-accordion-collapse`}
      onChange={handleCollapseChange}
    >
      {panels.map((panel, i) => {
        const { header, content } = panel;
        return (
          <Panel
            // eslint-disable-next-line
            key={`accordion-panel-${id}-${i}`}
            header={header}
            forceRender
            css={style.panel}
          >
            <PanelContent
              key={`${i.toString()}-panel-content`}
              id={`${i.toString()}-panel-content`}
              type={content.type}
              items={content.items}
              total={content.total}
            />
          </Panel>
        );
      })}
    </Collapse>
  );
};

Accordion.propTypes = {
  panels: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      content: PropTypes.object,
    })
  ).isRequired,
};

export default Accordion;
